<template>
  <div class="modal rounded">
    <ul>
      <li v-if="content.dateCreated"><i class="material-icons">date_range</i><div>Date added</div> <span v-html="content.dateCreated"></span></li>
      <li v-if="content.createdBy"><i class="material-icons">account_circle</i><div>By</div> <span v-html="content.createdBy"></span></li>
      <li v-if="content.language"><i class="material-icons">language</i><div>Language</div> <span v-html="content.language"></span></li>
    </ul>
    <div class="content" v-html="content.description"></div>
  </div>
</template>

<script>
import { modalMixin } from '@/mixins/modalMixin.js'
export default {
  name: 'description-modal',
  mixins: [modalMixin]
}
</script>

<style lang="scss" scoped>
.modal {
  padding: 25px;
}
ul {
  padding: 0;
  list-style: none;
  max-width: 250px;
  font-size: 14px;
  margin-bottom: 2em;

  li {
    display: flex;
    margin-bottom: 0.3em;
    div,
    i {
      color: #1a1a9b;
    }
    div {
      width: 100px;
    }
    i {
      margin-right: 15px;
    }
  }
}
</style>